import { AfterViewInit, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './core/http/http.service';
import { Router } from '@angular/router';
import {
  APP_COMPONENTS,
  IAppComponent,
  IAuth,
  IUser,
  ROLES
} from './shared/models/login.model';
import * as LogRocket from 'logrocket';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UnsubscribeOnDestroyAdapter } from './core/unsuscribe-adapter/unsuscribe-adapter';
import { UserService } from '@shared/services/user.service';
import { IModuleUserPermission } from './main/users/models/user-privileges.model';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends UnsubscribeOnDestroyAdapter
  implements AfterViewInit, OnInit {
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private components: IAppComponent[] = APP_COMPONENTS;

  public isMobile: boolean;
  public isTablet: boolean;
  public isDesktopDevice: boolean;

  constructor(
    private service: HttpService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private userService: UserService
  ) {
    super();
    this.initLogRocket();
  }

  ngOnInit(): void {
    this.deviceFunction();
  }

  ngAfterViewInit() {
    this.validateComponent();
    if (this.isDesktopDevice || this.isMobile || this.isTablet) {
      this.deviceFunction();
    }
  }

  private initLogRocket(): void {
    if (environment.instance === 'pdn') {
      LogRocket.init(environment.apiIdLogRocket);
    } else if (environment.instance === 'uat') {
      LogRocket.init(environment.apiIdLogRocketUat);
    }
  }

  private identifyLogRocketUser(auth: IAuth): void {
    LogRocket.identify(auth.id.toString(), {
      name: `${auth.name} ${auth.last_name}`,
      email: auth.username
    });
  }

  private validateComponent() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const currentPath = window.location.pathname;
    const publicRoutes = ['/get-quote'];
    const isPublicRoute = publicRoutes.some(route => currentPath.startsWith(route));
    if (isPublicRoute) {
      return;
    }

    // Identify the module to render by URL params
    this.components.forEach((component, idx) => {
      const params = this.getParamsUrl(component.name, urlParams);
      if (params) {
        this.components[idx].params = params;
        this.components[idx].active = true;
      }
    });

    const isActiveComponent = this.components.some(
      component => component.active
    );

    if (isActiveComponent) {
      const activeComponent = this.components.filter(
        component => component.active
      )[0];
      if (activeComponent.main) {
        this.identifyUser(activeComponent.params);
      } else {
        this.router.navigate([activeComponent.path + activeComponent.params]);
      }
    } else {
      const localDataUser: IUser = this.userService.userInfo;
      if (
        !(
          localDataUser != null &&
          localDataUser.role != null &&
          localStorage.getItem('JWT_TOKEN') != null
        )
      ) {
        window.location.href = environment.domainLoginPortal;
      } else {
        this.identifyLogRocketUser({
          expires_in: null,
          token: null,
          type: null,
          ...localDataUser
        });
        if (window.location.pathname.length === 1) {
          this.switchDashboard(localDataUser);
        }
      }
    }
  }

  private identifyUser(resultParams: string): void {
    resultParams = atob(resultParams);
    this.subs.add(
      this.service.post('user/verifyToken', { token: resultParams }).subscribe(
        (data: IAuth) => {
          this.setToken(resultParams);
          this.identifyLogRocketUser(data);
          this.userService.userData = data;
          this.userService.getUserPermissions();
          this.getModulePermissions(data);
        },
        error => {
          window.location.href = environment.domainLoginPortal;
        }
      )
    );
  }

  private getModulePermissions(data: IAuth): void {
    this.subs.add(
      this.service
        .get<IModuleUserPermission>(`user_permission/${data.id}`, {})
        .subscribe(
          response => {
            if (response && Object.keys(response).length) {
              this.userService.userModulesData = response;
            } else {
              Swal.fire(
                'Contact an administrator',
                'You do not have any module access assigned to you',
                'warning'
              );
            }
            this.switchDashboard(data);
          },
          error => {
            window.location.href = environment.domainLoginPortal;
          }
        )
    );
  }

  private switchDashboard(user: IUser): void {
    if (ROLES.includes(user.role.name)) {
      this.router.navigate(['/main']);
    }
  }

  private getParamsUrl(param: string, urlParams: URLSearchParams): string {
    return urlParams.get(param);
  }

  setToken(token: string): void {
    localStorage.setItem(this.JWT_TOKEN, token);
  var expires = (2*60*60); // default: 1h
   // var expires =30;
    var date = new Date();
    let schedule:string =String( Math.round((date.setSeconds(date.getSeconds()+expires))/1000));
  //  let schedule:string =String( Math.round((expires*1000)));
    console.log("Expired= "+ schedule);
    localStorage.setItem(this.JWT_TOKEN+'_time', schedule);
  }

  cleanParams() {
    const uri = window.location.toString();
    if (uri.indexOf('?') > 0) {
      const clean_uri = uri.substring(0, uri.indexOf('?'));
      window.history.replaceState({}, document.title, clean_uri);
    }
  }

  deviceFunction() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }
}
